import { safeString } from '@exodus/safe-string';
export const ETH_NULL_ADDRESS = '0x0000000000000000000000000000000000000000';
export const ALLOWED_AMOUNTS_DIFF_PERCENTAGE = 10;
export const FEE_ASSET_BY_CHAIN_ID = new Map([
    [1, 'ETH'],
    [137, 'MATICNATIVE'],
    [56, 'BNBBSC'],
    [250, 'FTMMAINNET'],
    [43_114, 'AVAXC'],
    [8453, 'BASEMAINNET'],
]);
export const LOGS = Object.freeze({
    CREATE_CHAINED_ORDER: safeString `Creating chained order`,
    CHECKING_ALLOWANCE: safeString `Checking allowance`,
    CHECKING_ORDER_VALIDITY: safeString `Checking order validity`,
    CREATING_ORDER: safeString `Creating order in the exchange-server`,
    DECODING_TX: safeString `Decoding transaction`,
    FAILED_TO_CREATE_ORDER: safeString `Failed to create order`,
    FAILED_TO_GET_TX: safeString `Failed to get tx`,
    FAILED_TO_SEND_TX: safeString `Failed to send tx`,
    FAILED_TO_VALIDATE_ORDER: safeString `Failed to validate order`,
    GETTING_PROVIDER_ORDER: safeString `Getting provider order`,
    SENDING_TX: safeString `Sending TX`,
    UPDATING_ORDER: safeString `Updating order with txId`,
    SIMULATION_FAILED: safeString `Simulation failed`,
    SIMULATING_TX: safeString `Simulating Tx`,
});
export const XO_ID = 'XOUSsolana2A78FEA2';
